<div class="page-wrapper">
  <div class="pricing-card">

    <!-- Header -->
    <div class="card-header-block">
      <img src="logo-login.svg" alt="aInstitute Logo" class="card-logo" />
      <div class="step-badge">Step 3 of 4</div>
    </div>

    <div class="pricing-header">
      <h1 class="pricing-title">Choose Your Plan</h1>
      <p class="pricing-subtitle">
        Select the subscription that best fits your institution's size and requirements.
        All plans include free onboarding support.
      </p>
    </div>

    <div class="loading-state" *ngIf="isLoading">Loading plans…</div>

    <form [formGroup]="subscriptionForm" (ngSubmit)="submit()" novalidate *ngIf="!isLoading">
      <div class="plans-grid">
        @for (plan of plans; track plan.name) {
          <div
            class="plan-card"
            [class.is-featured]="plan.isFeatured"
            [class.is-selected]="selectedPlanName === plan.name"
            (click)="selectPlan(plan.name)"
          >
            @if (plan.isFeatured) {
              <div class="featured-ribbon">Most Popular</div>
            }

            <div class="plan-top">
              <h3 class="plan-name">{{ plan.name }}</h3>
              <p class="plan-desc">{{ plan.description }}</p>
            </div>

            <div class="plan-price">
              <span class="price-amount">₹{{ plan.price }}</span>
              <span class="price-unit">/student/year</span>
            </div>

            <ul class="plan-features">
              @for (feature of plan.features; track feature) {
                <li class="feature-item">
                  <svg class="check-icon" width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  {{ feature }}
                </li>
              }
            </ul>

            <button
              type="button"
              class="plan-select-btn"
              [class.selected]="selectedPlanName === plan.name"
              (click)="selectPlan(plan.name)"
            >
              <span *ngIf="selectedPlanName !== plan.name">Select Plan</span>
              <span *ngIf="selectedPlanName === plan.name" class="selected-label">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Selected
              </span>
            </button>
          </div>
        }
      </div>

      <div class="form-footer">
        <p class="footer-note">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Pricing is billed annually. You can upgrade or change plans anytime.
        </p>
        <div class="footer-actions">
          <button type="button" class="btn-secondary" (click)="backToInstituteInfo()">
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
              <path d="M13 8H3M7 4l-4 4 4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Back
          </button>
          <button type="submit" class="btn-primary" [disabled]="!selectedPlanName">
            Continue
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </form>

  </div>
</div>
